import axios from 'axios';

import { Util } from '../common/util/util';

export const PagesApi = () => ({
  async getPages(type: string) {
    const { data } = await axios({
      method: 'get',
      baseURL: process.env.REACT_APP_BASE_URL_API,
      url: `/api/pages/${type}`,
      headers: {
        token: Util.getTokenSecurity(),
      },
    });
    return data;
  },
  async setSave(type: string, content: any, sessionToken: string) {
    const { data } = await axios({
      method: 'patch',
      baseURL: process.env.REACT_APP_BASE_URL_API,
      url: `/api/admin/pages/${type}`,
      headers: {
        'session-token': sessionToken,
      },
      data: {
        title: type,
        content: content,
      },
    });
    return data;
  },
});
